module.exports = __webpack_public_path__ + "img/videoarrow.e5c40e9d.svg";